import {
  cssClass,
  divWithStyle,
} from '@tableau/data-catalog-shared';
import { TabStyles } from '@tableau/widgets';

const Colors = TabStyles.Colors;
const Spacing = TabStyles.Spacing;
const Sizing = TabStyles.Sizing;
const Typography = TabStyles.Typography;

export const LineageNavContainer = divWithStyle('LineageNavContainer', {
  flex: 'none',
  width: 300,
  display: 'flex',
  flexDirection: 'column', // Defining the FlexDirection is necessary so that the child can fill the height
  lineHeight: '1.3em',
});

export const lineageNavCssClass = cssClass('LineageNav', {
  borderLeft: `${Sizing.BorderWidth}px solid ${Colors.L6}`,
  padding: `${Spacing.DefaultSpace}px ${Spacing.MediumSpace}px`
});

export const LineageNavHeader = divWithStyle('LineageNavHeader', {
  fontSize: Typography.Sizing.XLarge,
  padding: Spacing.DefaultSpace,
  paddingBottom: Spacing.ExtraLargeSpace
});

export const lineageNavFilterIndicatorHeight = 20;

export const lineageHeaderClass = cssClass('lineageHeaderClass', {
  justifyContent: 'space-between',
  height: `${lineageNavFilterIndicatorHeight}px`,
  lineHeight: `${lineageNavFilterIndicatorHeight}px`,
});
